import React, { Component } from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import Panel from '../../../../../../components/angle/Panel/index';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Spinner from '../../../../../../components/Spinner/index';
import ProspectusForm from '../../components/ProspectusForm';
import FilingListGrid from '../../../../components/FilingListGrid';
import HistoryGrid from '../../components/HistoryGrid';

import {
    updateProspectusHistoryItemSelected,
    handleViewProspectusVisibility,
    handleEditProspectusVisibility,
    fetchProspectusFilings
} from '../../../../../../services/redux/employee/prospectus/actions';

import {
    fetchFilingById,
    updateFilingInfoData,
    fetchClientData,
    fetchStateData
} from '../../../../../../services/redux/employee/filing/actions';

class ViewProspectus extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: 1
        };
    }
    onEditClick = () => {
        let {
            handleViewProspectusVisibility,
            handleEditProspectusVisibility
        } = this.props;
        handleViewProspectusVisibility(false);
        handleEditProspectusVisibility(true);
    };
    onBackClick = () => {
        let { handleViewProspectusVisibility, location, history } = this.props;
        if (location.from && location.from !== '/client-details') {
            history.push({
                pathname: location.from,
                from: '/client-details'
            });
        } else {
            handleViewProspectusVisibility(false);
        }
    };

    onChangeTab = key => {
        this.setState({ activeTab: key });
    };

    reviewPendingFiling = data => {
        let {
            history,
            prospectus,
            fetchFilingById,
            fetchClientData,
            fetchStateData,
            updateFilingInfoData
        } = this.props;

        fetchFilingById(data.filingId).then(response => {
            if (response) {
                fetchClientData(response.clientId);
                fetchStateData(response.stateId);
            }
        });
        updateFilingInfoData({
            ...data,
            prospectusName: prospectus.editProspectusData.name
        });

        history.push({ pathname: '/filing-details', from: '/client-details' });
    };

    render() {
        let { prospectus, updateProspectusHistoryItemSelected } = this.props;
        let { activeTab } = this.state;
        let backButton = (
            <button
                type="button"
                className="btn btn-default btn-bordered green-button"
                onClick={this.onBackClick}
            >
                Back
            </button>
        );
        let editButton = (
            <button
                type="button"
                className="btn btn-default btn-bordered green-button"
                onClick={this.onEditClick}
            >
                Edit
            </button>
        );

        return (
            <div className="panel">
                <Tabs
                    id="tabID"
                    onSelect={this.onChangeTab}
                    activeKey={this.state.activeTab}
                    mountOnEnter={true}
                    unmountOnExit={true}
                >
                    <Tab eventKey={1} title="View Prospectus">
                        <Panel>
                            <div className="col-lg-6 col-md-8 col-sm-12">
                                <ProspectusForm
                                    prospectusData={
                                        prospectus.editProspectusData
                                    }
                                    isEditable={false}
                                />
                            </div>
                        </Panel>
                    </Tab>
                    <Tab eventKey={2} title="Filings">
                        <FilingListGrid
                            dataList={prospectus.filings}
                            handleReviewButtonClick={this.reviewPendingFiling}
                        />
                    </Tab>
                    <Tab eventKey={3} title="Change Log">
                        <HistoryGrid
                            dataList={prospectus.history}
                            updateSelected={updateProspectusHistoryItemSelected}
                        />
                        {prospectus.selectedHistoryItem &&
                            prospectus.selectedHistoryItem.prospectusId && (
                                <Panel
                                    showHeader
                                    header="History Item Details"
                                    panelStyle="panel-default m0"
                                >
                                    <div className="col-lg-6 col-md-8 col-sm-12">
                                        <ProspectusForm
                                            prospectusData={
                                                prospectus.selectedHistoryItem
                                            }
                                            isEditable={false}
                                        />
                                    </div>
                                </Panel>
                            )}
                    </Tab>
                    <br />
                    {activeTab === 1 && editButton}
                    {backButton}
                </Tabs>
                {prospectus.fetching && <Spinner />}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    prospectus: state.employee.prospectus
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            updateProspectusHistoryItemSelected,
            handleViewProspectusVisibility,
            handleEditProspectusVisibility,
            fetchProspectusFilings,
            fetchFilingById,
            updateFilingInfoData,
            fetchClientData,
            fetchStateData
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(ViewProspectus));



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/screens/ClientDetails/screens/ViewProspectus/index.js